export default __webpack_public_path__ + "static/media/hero-mobile.31245c61.png";